import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useCurrentUser } from "@/hooks/useCurrentUser";

/** True when the signed-in user has the `admin` role. */
export function useIsAdmin() {
  const { user } = useCurrentUser();
  const q = useQuery({
    queryKey: ["is-admin", user?.id ?? null],
    enabled: !!user,
    // Roles are effectively static during a session.
    staleTime: 30 * 60_000,
    gcTime: 60 * 60_000,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const { data, error } = await supabase.rpc("has_role", {
        _user_id: user!.id,
        _role: "admin",
      });
      if (error) throw error;
      return !!data;
    },
  });
  return { isAdmin: q.data ?? false, loading: q.isLoading };
}
